export default __webpack_public_path__ + "static/webinar-tablet-27d5d829d59e1d52364b5d1a06c41492.png";